import { useAuthStore } from '../stores/useAuthStore'
import type { VerifyOtpEmailUser } from '../entities/otp/types'

//TODO: Auto logout when JWT expires
// import { jwtDecode } from 'jwt-decode'

export interface AuthContextType {
  isAuthenticated: boolean
  token: string | null
  userId: string | null
  login: (token: string, userId: string, user?: VerifyOtpEmailUser | null) => void
  logout: () => void
}
export function useAuth(): AuthContextType {
  const token = useAuthStore((state) => state.token)
  const userId = useAuthStore((state) => state.userId)
  const login = useAuthStore((state) => state.login)
  const logout = useAuthStore((state) => state.logout)
  const isAuthenticated = !!token

  return {
    isAuthenticated,
    token,
    userId,
    login,
    logout,
  }
}
